document.addEventListener('DOMContentLoaded', () => {
  // Get the product title from the page
  const productTitleElement = document.querySelector('h1.heading');
  const productTitle = productTitleElement ? productTitleElement.textContent.trim() : '';

  // Hide the calculator if the title contains "Bullnose"
  const calculatorContainer = document.querySelector('.tile-calculator-container');
  if (productTitle.toLowerCase().includes('bullnose') && calculatorContainer) {
    calculatorContainer.style.display = 'none';
    return;
  }

  class TileCalculator {
    constructor() {
      this.debugElement = document.getElementById('calculator-debug');
      this.currentSqftElement = document.getElementById('current-sqft');

      this.elements = {
        lengthInput: document.querySelector('#tile-length'),
        widthInput: document.querySelector('#tile-width'),
        areaInput: document.querySelector('#tile-area'),
        quantityInput: document.querySelector('#tile-quantity'),
        extraCheckbox: document.querySelector("#add-cover-break")
      };

      if (!this.elements.lengthInput || !this.elements.widthInput || 
          !this.elements.areaInput || !this.elements.quantityInput) {
        return;
      }

      // Load the square footage from window.tileCalculatorData
      this.loadSquareFootage();
      this.finalizeSetup();
    }

    loadSquareFootage() {
      if (window.tileCalculatorData && window.tileCalculatorData.squareFeetPerBox) {
        this.squareFootagePerBox = parseFloat(window.tileCalculatorData.squareFeetPerBox);
      }

      if (isNaN(this.squareFootagePerBox) || this.squareFootagePerBox <= 0) {
        this.squareFootagePerBox = productTitle.toLowerCase().includes('mosaic') ? 1.0 : 15.5;
      }
    }

    finalizeSetup() {
      this.bindEvents();
      this.setupInputValidation();
      this.updateDebugDisplay();
      this.setupToggle();
      this.calculateBoxes();
    }

    updateDebugDisplay() {
      if (this.debugElement && this.currentSqftElement) {
        this.currentSqftElement.textContent = this.squareFootagePerBox.toFixed(2);
      }
    }

    setupInputValidation() {
      const numberInputs = [
        this.elements.lengthInput,
        this.elements.widthInput,
        this.elements.areaInput,
        this.elements.quantityInput
      ];

      numberInputs.forEach(input => {
        if (input) {
          input.setAttribute('min', '0');
          input.addEventListener('keypress', (e) => {
            if (e.key === '-' || e.key === '+') {
              e.preventDefault();
            }
          });
          input.addEventListener('blur', () => {
            const value = parseFloat(input.value);
            if (isNaN(value) || value < 0) {
              input.value = '';
            }
          });
        }
      });
    }

    setupToggle() {
      const toggleBtn = document.getElementById('toggle-length-width');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const section = document.getElementById('length-width-section');
          if (section) {
            section.classList.toggle('hidden');
          }
        });
      }
    }

    bindEvents() {
      this.elements.lengthInput?.addEventListener('input', () => this.calculateArea());
      this.elements.widthInput?.addEventListener('input', () => this.calculateArea());
      this.elements.areaInput?.addEventListener('input', () => {
        this.clearLengthWidth();
        this.calculateBoxes();
      });
      this.elements.quantityInput?.addEventListener('input', () => {
        this.clearLengthWidth();
        this.calculateArea();
        this.syncQuantityToCart();
      });
      if (this.elements.extraCheckbox) {
        this.elements.extraCheckbox.addEventListener('change', () => this.calculateBoxes());
      }
    }

    clearLengthWidth() {
      if (this.elements.lengthInput) this.elements.lengthInput.value = '';
      if (this.elements.widthInput) this.elements.widthInput.value = '';
    }

    calculateArea() {
      if (document.activeElement === this.elements.quantityInput) {
        let boxes = parseFloat(this.elements.quantityInput.value) || 0;
        let area = (boxes * this.squareFootagePerBox).toFixed(2);
        this.elements.areaInput.value = area;
        return;
      }
      
      let length = parseFloat(this.elements.lengthInput.value) || 0;
      let width = parseFloat(this.elements.widthInput.value) || 0;
      let area = (length * width).toFixed(2);
      this.elements.areaInput.value = area;
      this.calculateBoxes();
    }

    syncQuantityToCart() {
      let boxes = parseInt(this.elements.quantityInput.value) || 1;
      const shopifyQty = document.querySelector('input[name="quantity"]');
      if (shopifyQty) {
        shopifyQty.value = boxes;
        shopifyQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    calculateBoxes() {
      let area = parseFloat(this.elements.areaInput.value) || 0;
      let addExtra = this.elements.extraCheckbox?.checked || false;
      
      if (area > 0) {
        let boxesNeeded = Math.ceil(area / this.squareFootagePerBox);
        if (addExtra) {
          boxesNeeded = Math.ceil(boxesNeeded * 1.1);
        }
        this.elements.quantityInput.value = boxesNeeded;
        const shopifyQty = document.querySelector('input[name="quantity"]');
        if (shopifyQty) {
          shopifyQty.value = boxesNeeded;
          shopifyQty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        this.elements.quantityInput.value = 1;
        const shopifyQty = document.querySelector('input[name="quantity"]');
        if (shopifyQty) {
          shopifyQty.value = 1;
          shopifyQty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  if (calculatorContainer) {
    setTimeout(() => {
      const calculator = new TileCalculator();
    }, 1000);
  }
});